// Helper to parse rate limit errors. Matches both human-readable messages and
// Privy error codes ('too_many_requests') / messages ('Too many requests').
export function isRateLimitError(message: string): boolean {
	const lower = message.toLowerCase()
	return (
		lower.includes('max number') ||
		lower.includes('rate') ||
		lower.includes('wait') ||
		lower.includes('too many') ||
		lower.includes('too_many')
	)
}

// Helper to parse OTP verification errors
export function parseOtpError(message: string): string {
	const lower = message.toLowerCase()
	if (lower.includes('invalid') || lower.includes('incorrect') || lower.includes('wrong')) {
		return 'Invalid code. Please check and try again.'
	}
	if (lower.includes('expired')) {
		return 'Code expired. Please request a new one.'
	}
	return 'Verification failed. Please try again.'
}
